import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { deofuscate } from '@/utils/obfuscation';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { Variant } from '@/interfaces/transaction-result';

@Component({
  selector: 'app-result-actions',
  templateUrl: './result-actions.component.html',
  styleUrls: ['./result-actions.component.css'],
})
export class ResultActionsComponent implements OnInit {
  title: string = '';
  variant: Variant = 'success';
  id: number = 0;
  email: string = '';
  message: string = '';
  messageBold: string = '';
  subtitle: string = '';
  typeLicense: string = '';
  actionButtonPath = '';
  actionButtonText = '';

  // "/search/driver/result/:ofuscatedData"

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    { text: 'Buscar', path: '/search/driver' },
  ];

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.title = params.title || '';
      this.subtitle = params.subtitle || '';
      this.message = params.message || '';
      this.messageBold = params.messageBold || '';
      this.id = params.id || 0;
      this.actionButtonPath = params.actionButtonPath || '';
      this.actionButtonText = params.actionButtonText || '';
      this.email = params.email || '';
      this.variant = params.variant || 'success';

      if (this.actionButtonPath.includes('driver')) {
        this.breadcrums[1].path = '/search/driver';
      }
      if (this.actionButtonPath.includes('infraction')) {
        this.breadcrums[1].path = '/search/infraction';
      }

      if (this.variant === 'success') {
        this.title = `${this.title}`;
        this.subtitle = `${this.subtitle}`;
        this.messageBold = `${this.messageBold}`;
        this.message = `${this.message}`;
        this.actionButtonPath = `${this.actionButtonPath}`;
        this.actionButtonText = `${this.actionButtonText}`;
      }
      if (this.variant === 'failure') {
        this.subtitle = `${this.subtitle}`;
        this.actionButtonPath = `${this.actionButtonPath}`;
        this.actionButtonText = `${this.actionButtonText}`;
      }
    });
  }

}
